export const DOCSubscriptionPricingFormName = 'doc-subscription-pricing';

export enum DOCSubscriptionPricingFormFields {
  PackageType = 'packageType',
  TotalPrice = 'totalPrice',
  FirmWide = 'firmWide',
  SeatsAmount = 'seatsAmount',
}
